<div class="flex h-8 items-center justify-between">
  <div class="flex items-center gap-2">
    <div class="typo-h4-semibold text-primary-blue">{{ treatment.dentalCode }}</div>

    @if (treatment.longDescription) {
      <svg-icon class="shrink-0 text-text-light" key="px-16-info" size="sm" [libUiTooltip]="treatmentTooltip" tooltipPosition="bottom" />
      <ng-template #treatmentTooltip>
        <div class="typo-h5-book min-w-[18px]">{{ treatment.longDescription }}</div>
      </ng-template>
    }
  </div>
  <button class="btn-secondary-small h-full" (click)="onAddClick()">{{ 'charting_add_treatment_add_button_label' | translate }}</button>
</div>

<div class="flex justify-between gap-4 pr-1.5">
  <div class="typo-h4-medium text-text-primary">{{ treatment.description }}</div>
</div>
